const initState = { state: true, error: false };

const reducers = {
  show() {
    return { state: true, error: false };
  },
  hide() {
    return { state: false, error: false };
  },
  error() {
    return { state: false, error: true };
  },
};

export const loading = {
  state: initState,
  reducers: reducers,
};
